var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"panelRef",staticClass:"item-execution-map-panel"},[_c(_setup.MapBase,{ref:"mapBase",staticClass:"item-execution-map-panel__map",attrs:{"show-geo-search-control":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }